import { define } from 'wicked-elements'
const isSafari = typeof navigator !== 'undefined' && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent)

define('[data-component~="navigation"]', {
  init () {
    this.$button = this.element.querySelector('[data-menubttn]')
    this.$menuitems = this.element.querySelectorAll('[data-menuitem]')
    this.toggle = this.toggle.bind(this)
    this.openHeight = 0
    this.closedHeight = this.element.clientHeight
    this.lastScroll = 0
  },
  connected () {
    this.$button.addEventListener('click', this.toggle)
  },
  disconnected () {
    this.$button.removeEventListener('click', this.toggle)
  },
  toggle () {
    if (this.element.classList.contains('closed')) {
      this.lastScroll = window.scrollY
      this.element.classList.remove('closed')
      this.$menuitems.forEach($el => $el.classList.replace('hidden', 'block'))
      this.$button.setAttribute('aria-expanded', true)
      this.$button.innerHTML = 'Close'

      // Safari hack to avoid scroll jump
      if (isSafari && this.lastScroll > 0) {
        this.openHeight = this.element.clientHeight 
        window.scrollTo(0, window.scrollY + this.openHeight - this.closedHeight)
      }
    } else {
      this.element.classList.add('closed')
      this.$menuitems.forEach($el => $el.classList.replace('block', 'hidden'))
      this.$button.setAttribute('aria-expanded', false)
      this.$button.innerHTML = 'Menu'

      // Safari hack to avoid scroll jump
      if (isSafari && this.lastScroll > 0) {
        window.scrollTo(0, window.scrollY - this.openHeight + this.closedHeight)
        this.closedHeight = this.element.clientHeight
      }
    }
  }
})